import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { CampaignsResponseDataSchema, DataResponseWithPagination, GetCampaignsSchema } from "schema"
import { z } from "zod"

type Query = z.input<typeof GetCampaignsSchema> & { includeIds?: string[] | null }
type Response = DataResponseWithPagination<z.infer<typeof CampaignsResponseDataSchema>>
type OnSuccessFn = (data: Response) => void

export const getCampaignsQueryKey = (query: Query = {}) => ["campaigns", query]

type Props = {
  query?: Query
  onSuccess?: OnSuccessFn
}

export const campaignsQuery = ({ query, onSuccess }: Props) => {
  return queryOptions({
    queryKey: getCampaignsQueryKey(query),
    queryFn: async () => {
      const { data } = await axios.get<Response>("/campaigns", { params: query })

      if (query?.includeIds?.length) {
        const missingIds = query.includeIds.filter((id) => !data.data.some((e) => e.id === id))

        if (missingIds.length > 0) {
          const extraSearch = await axios.get<Response>("/campaigns", {
            params: {
              filterBy: {
                ids: missingIds,
              },
            },
          })

          const foundItems = extraSearch.data.data ?? []

          if (foundItems.length) {
            data.data.push(...foundItems)
          }
        }
      }

      onSuccess?.(data)
      return data.data
    },
  })
}
